import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import TimeModal from '../../common/TimeModal'

import * as Strings from './strings'
import * as configActions from '../../actions/Config'
import * as bookingSystemTimesActions from '../../actions/BookingSystemTimes'

class NewBookableTimeModal extends Component {
  state = {
    startTimeInput: '',
    endTimeInput: '',
    errorStartTime: '',
    errorEndTime: '',
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { bookingSystemTimes } = this.props

    if (
      !nextProps.bookingSystemTimes.isCreating &&
      nextProps.bookingSystemTimes.errorCreating === null &&
      bookingSystemTimes.isCreating
    ) {
      this.props.hideCreateBookingSystemTimeModal()
      this.resetFields()
      this.props.showSnackbar(Strings.default.TIME_CREATED)
    } else if (
      !nextProps.bookingSystemTimes.isCreating &&
      nextProps.bookingSystemTimes.errorCreating !== null &&
      bookingSystemTimes.isCreating
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  create() {
    const { user, bookingSystemTimes } = this.props
    const { startTimeInput, endTimeInput } = this.state

    this.setState({ errorMessage: '' })

    if (startTimeInput === '') {
      this.setState({ errorStartTime: Strings.default.MANDATORY_FIELD })
    }

    if (endTimeInput === '') {
      this.setState({ errorEndTime: Strings.default.MANDATORY_FIELD })
    }

    if (startTimeInput !== '' && endTimeInput !== '') {
      const postData = {
        start: startTimeInput,
        end: endTimeInput
      }

      this.props.tryCreateBookingSystemTime(
        user.token,
        bookingSystemTimes.selected,
        postData
      )
    }
  }

  resetFields() {
    this.setState({
      startTimeInput: '',
      endTimeInput: '',
      errorStartTime: '',
      errorEndTime: '',
      errorMessage: ''
    })
  }

  render() {
    const { config, bookingSystemTimes } = this.props
    const {
      startTimeInput,
      endTimeInput,
      errorStartTime,
      errorEndTime,
      errorMessage
    } = this.state

    return (
      <TimeModal
        show={config.createBookingSystemTimeModal.show}
        hide={() => {
          this.resetFields()
          this.props.hideCreateBookingSystemTimeModal()
        }}
        startTimeInput={startTimeInput}
        onChangeStartTimeInput={text =>
          this.setState({
            startTimeInput: text,
            errorStartTime: '',
            errorMessage: ''
          })
        }
        errorStartTime={errorStartTime}
        endTimeInput={endTimeInput}
        onChangeEndTimeInput={text => {
          this.setState({
            endTimeInput: text,
            errorEndTime: '',
            errorMessage: ''
          })
        }}
        errorEndTime={errorEndTime}
        header={Strings.default.NEW_TIME}
        information={Strings.default.NEW_TIME_INFORMATION}
        onDone={() => this.create()}
        loading={bookingSystemTimes.isCreating}
        errorMessage={errorMessage}
      />
    )
  }
}

function mapStateToProps({ config, data, user, bookingSystemTimes }) {
  return { config, data, user, bookingSystemTimes }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...bookingSystemTimesActions },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewBookableTimeModal)



// WEBPACK FOOTER //
// ./src/components/containers/NewBookableTimeModal/index.js